module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.dialogId,
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.confirmationTitle))])])]), _vm._v(" "), (!_vm.htmlText) ? _c('div', {
    staticClass: "modal-body table-responsive"
  }, [_vm._t("default")], 2) : _c('div', {
    staticClass: "modal-body table-responsive",
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.noButtonDisable
    },
    on: {
      "click": function($event) {
        return _vm.onNoConfirmation()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.noButtonText) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    class: [this.colorRed ? 'btn-danger' : 'dialog-btn-primary'],
    attrs: {
      "type": "button",
      "disabled": _vm.yesButtonDisable
    },
    on: {
      "click": function($event) {
        return _vm.onYesConfirmation()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.yesButtonText) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16e8f212","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tools/Dialogs/ConfirmationDialog.vue
// module id = 409
// module chunks = 1 2